<div class="view-container">
  <mat-card class="missing-sage-codes">
    <div class="missing-sage-codes__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>warning</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Packs missing a Sage item code</h1>
      </div>
      <button type="button" mat-stroked-button (click)="load()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>

    <p class="missing-sage-codes__intro">{{ missingWarning }}</p>
    <p class="missing-sage-codes__intro">
      One missing code stops that order’s invoice. On a grouped distributor invoice, one missing code stops the whole group.
    </p>
    <p class="missing-sage-codes__intro">{{ helper }}</p>
    @if (incomplete) {
      <p class="missing-sage-codes__pending">Some packs could not be checked. Refresh to try again.</p>
    }

    <mat-form-field appearance="outline" class="missing-sage-codes__search" subscriptSizing="dynamic">
      <input matInput placeholder="Search by package id, medicine, or label" [formControl]="searchInput" />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    @if (loading) {
      <p class="missing-sage-codes__status">
        Checking packs… {{ medicinesDone }} of {{ medicineTotal }} medicines
      </p>
    } @else {
      <p class="missing-sage-codes__status">{{ visibleRows.length }} packs</p>
    }

    <div class="mbp-table-wrap">
      <table mat-table [dataSource]="pagedRows" class="mbp-data-table missing-sage-codes__table">
        <ng-container matColumnDef="package_id">
          <th mat-header-cell *matHeaderCellDef>Package id</th>
          <td mat-cell *matCellDef="let row">{{ row.packageId }}</td>
        </ng-container>

        <ng-container matColumnDef="medicine">
          <th mat-header-cell *matHeaderCellDef>Medicine</th>
          <td mat-cell *matCellDef="let row">
            <a [routerLink]="['/portal/medicine/view', row.medicineId]">{{ row.medicineName }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="strength">
          <th mat-header-cell *matHeaderCellDef>Strength</th>
          <td mat-cell *matCellDef="let row">{{ row.strength }}</td>
        </ng-container>

        <ng-container matColumnDef="package_type">
          <th mat-header-cell *matHeaderCellDef>Package type</th>
          <td mat-cell *matCellDef="let row">{{ row.packageType }}</td>
        </ng-container>

        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef>Label</th>
          <td mat-cell *matCellDef="let row">{{ row.label }}</td>
        </ng-container>

        <ng-container matColumnDef="sage_item_code">
          <th mat-header-cell *matHeaderCellDef>Sage item code</th>
          <td mat-cell *matCellDef="let row" class="sage-item-code-col">
            @if (perm.canEditMedicineCatalogue()) {
              <div class="missing-sage-codes__code">
                <input
                  class="missing-sage-codes__input"
                  type="text"
                  autocomplete="off"
                  placeholder="e.g. MBP-FG-101"
                  [value]="codeFor(row)"
                  (input)="onCodeInput(row, $any($event.target).value)"
                />
                <button
                  type="button"
                  mat-stroked-button
                  [disabled]="savingPackageId !== null || loading"
                  (click)="save(row)"
                >
                  {{ savingPackageId === row.packageId ? 'Saving…' : 'Save' }}
                </button>
              </div>
            }
            <span class="sage-item-code-missing">{{ missingWarning }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    @if (!loading && visibleRows.length > 0) {
      <mat-paginator
        class="missing-sage-codes__paginator"
        [length]="visibleRows.length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
        (page)="onPageChange($event)"
        aria-label="Select page of packs"
      ></mat-paginator>
    }

    @if (!loading && rows.length === 0 && !incomplete) {
      <p class="missing-sage-codes__empty">No packs are missing a Sage item code.</p>
    }
    @if (!loading && rows.length > 0 && visibleRows.length === 0) {
      <p class="missing-sage-codes__empty">No packs match this search.</p>
    }
  </mat-card>
</div>
